// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateNewDashboardButton-container {
  width: 311px;
  height: 297px;
}
.CreateNewDashboardButton-container .CreateNewDashboardButton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: var(--spacing_unit_3);
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 700;
  color: var(--color_neutral_800);
}`, "",{"version":3,"sources":["webpack://./src/components/CreateNewDashboardButton/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EAEA,WAAA;EACA,YAAA;EAEA,eAAA;EACA,gBAAA;EACA,+BAAA;AADJ","sourcesContent":[".CreateNewDashboardButton-container {\n  width: 311px;\n  height: 297px;\n\n  .CreateNewDashboardButton {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    row-gap: var(--spacing_unit_3);\n\n    width: 100%;\n    height: 100%;\n\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--color_neutral_800);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
